import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { SimilarResidentsTable } from "./SimilarResidentsTable";
import { H2 } from "../../../text";
import { NotMatchingResidentBanner } from "./styles";
/**
 * SimilarResidents component displays a table of residents with similar demographics to identify possible duplicates.
 *
 * @component
 * @param {Object} props - The component's props.
 * @param {Array<Object>} props.items - An array of similar resident objects to display in the table.
 * @param {Function} props.modal - A modal component to handle resident file actions.
 * @returns {JSX.Element | null} A table displaying the similar residents' demographic details or null if there are no similar residents.
 *
 * @remarks
 * This table allows users to identify residents with similar information. It provides a list of potential duplicates based on demographic matches.
 */
export const SimilarResidents = ({ items: similarResidents, modal: ResidentFilesModal, }) => {
    const { values: { resident_demographics }, } = useFormikContext();
    if (!similarResidents.length)
        return null;
    const isSelectedResidentFullMatch = (id) => {
        const resident = similarResidents.find(item => item.resident.id === id);
        return resident ? resident.match === "100%" : false;
    };
    return (_jsxs(_Fragment, { children: [_jsx(H2, { style: { marginTop: "32px", marginBottom: "16px" }, children: "Possible Duplicates" }), _jsx(NotMatchingResidentBanner, { id: isSelectedResidentFullMatch(resident_demographics.similar_resident)
                    ? ""
                    : resident_demographics.similar_resident, children: _jsx(SimilarResidentsTable, { similarResidents: similarResidents, activeRowId: isSelectedResidentFullMatch(resident_demographics.similar_resident)
                        ? ""
                        : resident_demographics.similar_resident, selectable: true, formValues: {
                        first_name: resident_demographics.resident_firstName,
                        last_name: resident_demographics.resident_lastName,
                        gender: resident_demographics.resident_gender,
                        date_of_birth: resident_demographics.resident_dateOfBirth,
                    }, residentFilesModal: ResidentFilesModal }) })] }));
};
